//-------------------------------------------------------------------------------------------------- Imports
import { Row } from "antd";
import { ResponsePackageItem } from "../../../types/common";
import { StyleSheet } from "../../../StyleSheet";
import HireServicesComponent from "./HireServicesComponent";
import WaitingServicesComponent from "./WaitingServicesComponent";
import { useMemo, useState } from "react";
import _ from "lodash";
import CollapsibleGroupCard from "./CollapsibleGroupCard";

//-------------------------------------------------------------------------------------------------- Interfaces
interface PackagesProps {
    packages: Array<ResponsePackageItem>;
};

//-------------------------------------------------------------------------------------------------- Component
const Packages = (props: PackagesProps) => {
    const { packages } = props;
    const [openGroupName, setOpenGroupName] = useState<string | null>(null);

    const handleToggleCard = (name: 'INDIVIDUAL' | 'FAMILIAR') => {
        setOpenGroupName(name === openGroupName ? null : name);
    };

    const memoizedData = useMemo(() => {
        const mmPackages = packages.filter(
            (elem: ResponsePackageItem) => _.isEqual(elem.status, "hire-megamovil")
        );

        const groupedMegaMovil = _.groupBy(mmPackages, 'packageType');

        return {
            groupedMegaMovil,
            otherPackages: packages.filter(
                (elem: ResponsePackageItem) => !_.isEqual(elem.status, "hire-megamovil")
            ),
        };
    }, [packages]);

    const { groupedMegaMovil, otherPackages } = memoizedData;


    const renderCompopnentPerStatus = (pkg: ResponsePackageItem) => {
        switch (pkg.status) {
            case "hire":
                return <HireServicesComponent packageSrv={pkg} />
            case "waiting":
                return <WaitingServicesComponent packageSrv={pkg} />
            default:
                return null;
        };
    };

    return (
        <>
            {
                packages.length > 1 &&
                <Row style={styles.selectPackageContainer}>
                    <p style={{ color: "#ffffff", margin: 5 }}>
                        <b>Elige tu plan</b>
                    </p>
                </Row>
            }
            {groupedMegaMovil.INDIVIDUAL && (
                <CollapsibleGroupCard
                    key="INDIVIDUAL"
                    groupName={"Individual"} packages={groupedMegaMovil.INDIVIDUAL}
                    isExpanded={openGroupName === "INDIVIDUAL"}
                    onToggle={() => handleToggleCard("INDIVIDUAL")}
                />
            )}
            {groupedMegaMovil.FAMILIAR && (
                <CollapsibleGroupCard
                    key="FAMILIAR"
                    groupName={"Familiar"} packages={groupedMegaMovil.FAMILIAR}
                    isExpanded={openGroupName === "FAMILIAR"}
                    onToggle={() => handleToggleCard("FAMILIAR")}
                />
            )}
            {
                otherPackages.map((pkg, key: number) => (
                    <Row key={key} style={styles.mainContainer}>
                        {renderCompopnentPerStatus(pkg)}
                        {
                            key !== otherPackages.length - 1 &&
                            <div style={styles.dividierStyle} />
                        }
                    </Row>
                ))
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Services
const styles = StyleSheet.create({
    selectPackageContainer: {
        display: "flex",
        marginBottom: 10,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "0px 0px 25px 25px",
        backgroundColor: "#000000",
    },
    mainContainer: {
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 20px 10px 20px",
        margin: 0,
    },
    dividierStyle: {
        borderBottom: "1px solid #000000",
        width: "90%",
        paddingTop: 15,
    }
});

//-------------------------------------------------------------------------------------------------- Packages
export default Packages;
